import api from 'shared/api';
import { buildSortQuery, normalizeNextUrl } from 'shared/helpers';

export const updateLicenseProductFeature = (featureId, payload) => {
  const url = `/api/v1/license-product-features/${featureId}/`;
  return api.patch(url, payload);
};

export const deleteLicenseProductFeature = (featureId) => {
  const url = `/api/v1/license-product-features/${featureId}/`;
  return api.delete(url);
};

export const createLicenseFeature = (payload) => {
  const url = `/api/v1/license-product-features/`;
  return api.post(url, payload);
};

export const fetchLicenseProductFeatures = (licenseId, options = {}) => {
  const licenseFeatureFieldMapper = (id) =>
    id ? id.replace('product_feature.', 'product_feature__') : '';

  const { limit, offset, orderBy, next } = options;
  if (next) {
    return api.get(normalizeNextUrl(next));
  }
  const limitQuery = Number.isInteger(limit) ? `&limit=${limit}` : '';
  const offsetQuery = Number.isInteger(offset) ? `&offset=${offset}` : '';
  const orderQuery = buildSortQuery(orderBy, licenseFeatureFieldMapper);
  const query = `${limitQuery}${offsetQuery}${orderQuery}`;
  return api.get(
    `/api/v1/license-product-features/${
      query ? `?license=${licenseId}${query}` : `?license=${licenseId}`
    }`,
  );
};

export const patchLicense = (licenseId, payload) => {
  const url = `/api/v1/licenses/${licenseId}/`;
  return api.patch(url, payload);
};

export const fetchLicensesByLicenseUser = (
  licenseUserId,
  sortOptions = [],
  page = 0,
  pageSize = 20,
) =>
  api.get(
    `/api/v1/licenses/?license_users__id=${licenseUserId}&limit=${pageSize}&offset=${page * pageSize}${buildSortQuery(sortOptions)}`,
  );

export const fetchDevicesByLicenseUser = (
  licenseUserId,
  sortOptions = [],
  page = 0,
  pageSize = 20,
) => {
  return api.get(
    `/api/v1/devices/?license_users__id=${licenseUserId}&limit=${pageSize}&offset=${page * pageSize}${buildSortQuery(sortOptions)}`,
  );
};

export const fetchLicenseUserGroups = (
  licenseUserId,
  sortOptions = [],
  page = 0,
  pageSize = 20,
) =>
  api.get(
    `/api/v1/users/${licenseUserId}/groups/?limit=${pageSize}&offset=${page * pageSize}${buildSortQuery(sortOptions)}`,
  );
